import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { animationEasing, animationTimings } from 'src/shared/animations';
import { ResizableSidePanelService } from '../resizable-side-panel.service';

const animationOpening = animationTimings.prefersReducedMotion ? 0 : `${animationTimings.small} ${animationEasing.decelerated}`;
const animationClosing = animationTimings.prefersReducedMotion ? 0 : `${animationTimings.small} ${animationEasing.accelerated}`;

@Component({
  selector: 'ez-resizable-side-panel-drag-handle',
  templateUrl: './resizable-side-panel-drag-handle.component.html',
  styleUrls: ['./resizable-side-panel-drag-handle.component.scss'],
  imports: [MatIcon],
  animations: [
    trigger('slideInOutLeft', [
      state('true', style({ left: '-24px', visibility: 'visible' })),
      state('false', style({ left: '0', visibility: 'hidden' })),
      transition('false => true', group([
        animate(animationOpening),
        query('@slideInOutLeftChild', animateChild()),
      ])),
      transition('true => false', group([
        animate(animationClosing),
        query('@slideInOutLeftChild', animateChild()),
      ])),
    ]),
    trigger('slideInOutLeftChild', [
      state('true', style({ width: '28px' })),
      state('false', style({ width: '0' })),
      transition('false => true', animate(animationOpening)),
      transition('true => false', animate(animationClosing)),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizableSidePanelDragHandleComponent {

  readonly inDragArea = signal(false);
  readonly dragAreaActive = computed(() => this.inDragArea() || this.#resizableSidePanelService.isResizing());
  readonly dragHandleVisible = computed(() => this.#resizableSidePanelService.dragHandleVisible());

  readonly elementRef = inject(ElementRef);
  readonly #resizableSidePanelService = inject(ResizableSidePanelService);

}
